T.ContactUs = Class(
	/**
	 * @lends {T.ContactUs#}
	 */
	{
		__construct() {
			this.node = mkE({
				tag: 'div',
				className: 'corporate-contact-us contact-us container',
				els: [
					{
						tag: 'div',
						className: 'bs-row',
						els: [
							{
								tag: 'div',
								className: 'col-12 col-md-6',
								els: [
									{
										tag: 'div',
										className: 'corporate-contacts-title-caption',
										text: D.Lang.get('corporate-form.caption')
									},
									{
										tag: 'h2',
										className: 'h1',
										text: D.Lang.get('corporate-form.title')
									}
								]
							},
							{
								tag: 'div',
								className: 'col-12 col-md-6',
								els: [
									{
										tag: 'div',
										className: 'corporate-contacts-box contacts-box',
										els: [
											{
												tag: 'div',
												className: 'caption',
												text: D.Lang.get('corporate-form.drop-line')
											},
											{
												tag: 'a',
												href: 'mailto:hello@roadgames.com',
												className: 'mail',
												text: 'hello@roadgames.com'
											}
										]
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'bs-row',
						els: [
							{
								tag: 'div',
								className: 'col-12',
								els: [
									new T.ContactForm()
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'bs-row contacts-footer',
						els: [
							{
								tag: 'div',
								className: 'col-12 col-md-6',
								els: [
									{
										tag: 'div',
										className: 'contacts-footer-title',
										text: D.Lang.get('contact-form.footer.title')
									}
								]
							},
							{
								tag: 'div',
								className: 'col-12 col-md-6',
								els: [
									{
										tag: 'div',
										className: 'corporate-contacts-box',
										els: [
											{
												tag: 'a',
												href: 'mailto:krists@roadgames.com',
												className: 'mail',
												text: 'krists@roadgames.com'
											},
											{
												tag: 'div',
												className: 'krists'
											}
										]
									}
								]
							}
						]
					}
				]
			})
		}
	},
	mkE.Base
)